import React, { Component } from 'react'
function age(DOB) {
    var today = new Date();
    var birthDate = new Date(DOB);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age = age - 1;
    }

    return age;
}

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="davidvallejo-about" data-section="about">
        <h1>About Me</h1>
          <div class="vl"></div>
        <div className="davidvallejo-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">Who am I?</span>
                    <h2 className="davidvallejo-heading">Get to Know me</h2>
                    <p><strong>Hello! My name's David</strong> I am a {age("5/2/1994")} year old Software Engineer. I like to focus on Front-end software.
                    I graduated with a bachelor’s degree in Digital Media: Web design 
                    from the University of Central Florida. I use HTML, CSS, JavaScript and PHP, react, react native, GitHub and node.js 
                    along with Web design tools such as WordPress and adobe cc. 
                    My design and development practices are centered around the latest in User Interface and User Experience techniques. 
                    In regard to my coding abilities I was known at my last job as the CSS guru, because I can copy any design and implement self-developed CSS techniques to make things look pixel perfect and look really, really good.
                    I pride myself on making designs look amazing in very short turn over time. I like to say I studied for 6 years to do things in 5 minutes that takes others 3 days.
                    I have worked for multiple companies making web sites both from scratch and using tools such as WordPress, Elementor, and Shopify to ensure our clients get the web results they are looking for. 
                    My day to day routines at these companies would look somewhat like coming in touching base with team leads, reviewing for tickets, solving the tickets quickly and efficiently and designing and coding websites. 
                    I have also worked as a software engineer, for Revature where we would create applications with a Java backend and a bootstrapped front end. 
                    I consider myself a Jack of all trades and enjoy using all my skills to enhance and contribute to the internet </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="davidvallejo-about">
        <div className="davidvallejo-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do</span>
                <h2 className="davidvallejo-heading">my areas of focus</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <div className="div1">
                    <i className="icon-bulb" />
                </div>
                <div className="desc">
                    <h3>Web App Design & Development</h3>
                   
                    <p id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <div className="div2">
                    <i className="icon-phone3" />
                </div>
                <div className="desc">
                    <h3>Mobile Design & Development</h3>
                    <p id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <div className="div3">
                    <i className="icon-data" />
                </div>
                <div className="desc">
                    <h3>UI & UX Design</h3>
                    <p id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <div className="div1">
                    <i className="icon-bulb" />
                </div>
                <div className="desc">
                    <h3>Web App Design & Development</h3>
                    <p id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <div className="div2">
                    <i className="icon-phone3" />
                </div>
                <div className="desc">
                    <h3>Mobile Design & Development</h3>
                    <p id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <div className="div3">
                    <i className="icon-data" />
                </div>
                <div className="desc">
                    <h3>UI & UX Design</h3>
                    <p  id="services">Lorem Ipsum is simply dummy text of the printing
                     and typesetting industry. Lorem Ipsum has been the 
                     industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and
                       scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the 
                        leap into electronic typesetting, remaining 
                        essentially unchanged.
                       </p>
                </div>
                </div>
            </div>
  
            </div>
        </div>
        </section>
      </div>
    )
  }
}
